/**
 * authToken.js — DamyxIA cookie-only auth (P2.1 Cuadro Negro)
 * ===========================================================
 *
 * La autenticación real viaja en la cookie httpOnly `damyxia_token`,
 * que el navegador envía automáticamente porque
 * `axios.defaults.withCredentials = true` y `window.fetch` envuelto
 * con `credentials: 'include'` (ver `/src/index.js`).
 *
 * Este módulo queda NEUTRALIZADO pero mantiene su retval truthy
 * (`"cookie-session"`) porque ~10 archivos legados usan
 * `if (!getToken())` como proxy de "estoy autenticado". Cambiarlo a
 * null rompe esos guards. Para que el frontend NO envíe nunca un
 * header `Authorization: Bearer cookie-session`, los call sites deben
 * filtrarlo con `if (token && token !== 'cookie-session')` (ya hecho
 * en los 3 fetchs del flujo del 401 en prod) o mejor: eliminar el
 * import + el header en un refactor completo cuando haya espacio en
 * disco y presupuesto para tocar ~80 archivos.
 *
 * `setToken`/`clearToken` son no-ops mantenidos por compatibilidad.
 *
 * NO almacenar tokens reales aquí, NI en localStorage, NI en sessionStorage.
 */

const COOKIE_PLACEHOLDER = 'cookie-session';

export const getToken = () => COOKIE_PLACEHOLDER;
export const setToken = () => {};
export const clearToken = () => {};


